import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as employeeToDto } from '../../../../models/adapters/EmployeeAdapter';
import { employeeModified, employeeModifyFailed, modifyEmployee, ModifyEmployeePayload } from '../../../actions/setting/company/modifyEmployee';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function* modifyEmployeeSaga({ payload }: Action<ModifyEmployeePayload>) {
  const { employee, companyUuid } = payload;
  const token = yield getAuthenticationToken();
  const employeeDto = employeeToDto(employee);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateEmployee, token, {
    employee: employeeDto,
  });
  if (!response.error) {
    yield put(employeeModified({ employee, companyUuid, timestamp: moment() }));
  } else {
    yield put(employeeModifyFailed({ employee, companyUuid, timestamp: moment() }));
  }
}

export default function* watchModifyEmployeeSaga() {
  yield takeEvery(modifyEmployee, modifyEmployeeSaga);
}
